<template>
  <button class="w-6 h-9 md:w-4 md:h-7 border border-gray-300 bg-gray-200 rounded flex justify-center items-center transition-colors hover:bg-gray-300" @click="$emit('click')">
    <GrmIcon :icon="`arrow-${icon}`" />
  </button>
</template>

<script>
import GrmIcon from "@/components/Common/icon/GrmIcon";

export default {
  name: 'GrmSlideToggleBtn',
  components: {
    GrmIcon
  },
  props: {
    direction: { type: String, required: true },
    value: { type: Boolean, required: true }
  },
  computed: {
    icon() {
      switch (this.direction) {
        case 'top':
          return this.value ? 'top' : 'bottom';
        case 'right':
          return this.value ? 'right' : 'left';
        case 'bottom':
          return this.value ? 'bottom' : 'top';
        case 'left':
          return this.value ? 'left' : 'right';
        default:
          return ''
      }
    }
  }
}
</script>